import { render, staticRenderFns } from "./UploadExcel.vue?vue&type=template&id=4ec63b04&scoped=true"
import script from "./UploadExcel.vue?vue&type=script&lang=js"
export * from "./UploadExcel.vue?vue&type=script&lang=js"
import style0 from "./UploadExcel.vue?vue&type=style&index=0&id=4ec63b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec63b04",
  null
  
)

export default component.exports